import { Divider as GigerDivider, WithCommonProps } from '@shipengine/giger';
import { getDividerStyles } from './DividerStyles';

export enum DividerVariant {
    LARGE = 'large',
}

export type IDividerProps = WithCommonProps<{
    variant?: DividerVariant;
}>;

export const Divider = ({ variant, ...rest }: IDividerProps): JSX.Element => {
    return <GigerDivider css={getDividerStyles(variant)} {...rest} />;
};
